import React from "react";
import { YesNoPanel } from "../../../components/wizards/YesNoPanel";
import { WizardContext } from "../WizardContext";

export const MedicalReviewRequiredScreen = () => (
  <WizardContext.Consumer>
    {({ dispatch }) => (
      <>
        <YesNoPanel
          question="Does this case require medical review?"
          yesAction={() => {
            dispatch({
              type: "setAnswer",
              key: "medicalReviewRequired",
              value: true,
              doTransition: true,
            });
          }}
          noAction={() => {
            dispatch({
              type: "setAnswer",
              key: "medicalReviewRequired",
              value: false,
              doTransition: true,
            });
          }}
        />
      </>
    )}
  </WizardContext.Consumer>
);
